import { ReactNode } from 'react';

import { TableCell, TableRow } from '@occc/ui-design-system';

import { readableDate } from '@occc-app/lib/format';
import { DateTimeFormat } from '@occc-app/lib/date';
import { PointChangeViewItemData } from './types';
import { TransactionViewTableCell } from '../TransactionView/TransactionViewTableCell';

const NO_VALUE_PLACEHOLDER = '-';

export const PointChangeViewItem = (props: {
  item: PointChangeViewItemData;
  children?: ReactNode;
  isAmountHidden?: boolean;
}) => {
  const {
    item: { name = NO_VALUE_PLACEHOLDER, amount, offer },
    children,
    isAmountHidden = false,
  } = props;

  const noBottomBorder = !!children;
  const hasDates = offer && (offer.startDate || offer.endDate);

  return (
    <>
      <TableRow>
        <TransactionViewTableCell noBottomBorder={noBottomBorder}>{name}</TransactionViewTableCell>
        {hasDates && (
          <>
            <TransactionViewTableCell noBottomBorder={noBottomBorder}>
              {readableDate(offer?.startDate, DateTimeFormat.DateTimeFullMonth12h)}
            </TransactionViewTableCell>
            <TransactionViewTableCell noBottomBorder={noBottomBorder}>
              {readableDate(offer?.endDate, DateTimeFormat.DateTimeFullMonth12h)}
            </TransactionViewTableCell>
          </>
        )}
        <TransactionViewTableCell align='right' noBottomBorder={noBottomBorder}>
          {isAmountHidden ? null : amount}
        </TransactionViewTableCell>
      </TableRow>

      {children ? (
        <TableRow hover={false}>
          <TableCell
            colSpan={hasDates ? 4 : 2}
            sx={(theme) => ({
              '&:first-of-type': {
                padding: `0 ${theme.spacing(2)} ${theme.spacing(1)} ${theme.spacing(2)}`,
              },
            })}
          >
            {children}
          </TableCell>
        </TableRow>
      ) : null}
    </>
  );
};
